module.exports = __webpack_public_path__ + "img/hotel-1.2dc4b59f.jpeg";